module.exports = __webpack_public_path__ + "static/media/ic_db_portfolio.ed80fb23.svg";